<template>
  <avs-card noTitle>
    <template v-slot:content>
      <div
        id="tl-ref"
        style="height: 350px"
      ></div>
    </template>
  </avs-card>
</template>

<script>
import { TL } from "vue-timelinejs3"
import { MS_DURATIONS, toObject } from "@/utils/datetime"

const TLID = "tl-ref"

export default {
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      style: {},
      timeline: null
    }
  },
  methods: {
    formatEvent(data) {
      return {
        ...data,
        start_date: toObject(data.start_date),
        end_date: toObject(data.end_date)
      }
    },
    initialize(data) {
      if (data.length > 0) {
        // Compute new style

        // Wait next tick for style to apply before generating the timeline
        // Avoid some display bugs
        this.$nextTick(() => {
          this.timeline = new TL.Timeline(TLID, { events: data }, this.style)

          // Apply custom element color
          this.addColorTlMarkers()

          let $ = this
          // Add event listner to re-apply color marker on each menubar button click
          let menuBarBtns = document.querySelectorAll(".tl-menubar-button")
          menuBarBtns.forEach(el => {
            el.addEventListener("click", () => $.addColorTlMarkers())
          })
        })
      } else {
        // Set no display
        this.style = { display: "none" }
      }
    },
    addColorTlMarkers() {
      let timeMarkers = document.getElementsByClassName("tl-timemarker-content")
      timeMarkers.forEach((el, i) => {
        const item = this.timeline.getData(i)

        if (item.end_date) {
          // Compute time left before activity/task end date
          const timeLeft = item.end_date.data.date_obj - new Date()

          // Get conditional css color class
          let color = "grey"
          if (item.group === "Activity") {
            color = "blue"
          } else if (item.group === "Inspection") {
            color = "success"
          } else {
            if (item.status !== "Closed") {
              if (timeLeft > MS_DURATIONS.DAY_3) {
                color = "secondary"
              } else if (0 < timeLeft && timeLeft < MS_DURATIONS.DAY_3) {
                color = "warning"
              } else {
                color = "error"
              }
            }
          }

          // Apply color class
          el.classList.add(color)
        }
      })
    }
  },
  watch: {
    events: {
      handler(newValue, oldValue) {
        let data = newValue.map(e => this.formatEvent(e))
        this.initialize(data)
      }
    }
  }
}
</script>

<style lang="scss">
@import "~vue-timelinejs3/css/timeline.css";

/* TL background color */
#tl-ref {
  background-color: #dfe7ec;
}

.tl-slider-container-mask {
  background-color: #dfe7ec;
}

.tl-timeaxis-background {
  background-color: #dfe7ec;
}

// Setup default timemarker background color
.tl-timemarker .tl-timemarker-content-container {
  background-color: #8297b0;
}

.tl-timemarker.tl-timemarker-active .tl-timemarker-content-container {
  background-color: #627d9d;
}

/* TL timemarker text color */
#tl-ref
  .tl-timemarker.tl-timemarker-active
  .tl-timemarker-content-container
  .tl-timemarker-content
  .tl-timemarker-text
  h2.tl-headline {
  color: #fff;
}

#tl-ref
  .tl-timemarker
  .tl-timemarker-content-container
  .tl-timemarker-content
  .tl-timemarker-text
  h2.tl-headline {
  color: #fff;
}

/* TL slide navigation icon */
.tl-slidenav-next,
.tl-slidenav-previous {
  top: 25% !important;
}
.tl-slidenav-next .tl-slidenav-icon {
  white-space: nowrap;
}

/* TL no text-shadow */
.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-description,
.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-icon,
.tl-slidenav-next .tl-slidenav-content-container .tl-slidenav-title,
.tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-description,
.tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-icon,
.tl-slidenav-previous .tl-slidenav-content-container .tl-slidenav-title {
  text-shadow: none !important;
}

.tl-headline.tl-headline-fadeout {
  font-size: unset !important;
}
</style>
